import { appSettings } from '@shared/components/appSettings';
import { IDataEndPoint } from '@framework/interfaces/IEntity';
export interface IAppConfig {
  version: string;
  endpoint?: IDataEndPoint;
  element?: string | Object;
  templatePath?: string;
  controllerRouteRoot?: string;
  requiredPermissions?: Array<string>;
  gridAutoLoad?: number
  dateFormat?: string;
  timeFormat?: string;
  enablePredictiveText?: boolean;
  disableSpinner?: boolean;
  hideRefreshButton?: boolean;
  chartDefaultColors?: Array<any>;
  insertButtonSVG?: string;
  deleteButtonSVG?: string;
  copyFromButtonSVG?: string;
}
export const config: IAppConfig = {
  version: "1.0.0",
  element: "html",
  controllerRouteRoot: appSettings.controllerRouteRoot,
  dateFormat: "d M Y",
  timeFormat: "H:i:S",
  hideRefreshButton: false,
  insertButtonSVG: "/ts/framework/svg/insert-small.svg",
  deleteButtonSVG: "/ts/framework/svg/delete-small.svg",
  copyFromButtonSVG: "/ts/framework/svg/copy-from.svg"
};

export interface IPermissionConfig {
  permissions: string[];
}
